var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loading'),(_vm.$store.getters.loadCompleted)?_c('div',[_c('firstloginconfirm'),_c('notice'),_c('confirm'),_c('Cusnotice'),_c('router-view')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }